var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("キャンセルする")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.register.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.userCode,
                        expression: "user.userCode",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "32",
                      autocomplete: "off",
                      placeholder: "ユーザーID（必須）",
                      required: "",
                    },
                    domProps: { value: _vm.user.userCode },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "userCode", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(2),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.familyName,
                        expression: "user.familyName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "30",
                      autocomplete: "off",
                      placeholder: "姓（必須）",
                      required: "",
                    },
                    domProps: { value: _vm.user.familyName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "familyName", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "col-5" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.givenName,
                        expression: "user.givenName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "30",
                      autocomplete: "off",
                      placeholder: "名（必須）",
                      required: "",
                    },
                    domProps: { value: _vm.user.givenName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "givenName", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(3),
                _c("div", { staticClass: "col-4" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.familyKana,
                        expression: "user.familyKana",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "60",
                      autocomplete: "off",
                      placeholder: "せい（必須）",
                      required: "",
                    },
                    domProps: { value: _vm.user.familyKana },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "familyKana", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "col-5" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.givenKana,
                        expression: "user.givenKana",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "60",
                      autocomplete: "off",
                      placeholder: "めい（必須）",
                      required: "",
                    },
                    domProps: { value: _vm.user.givenKana },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "givenKana", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(4),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.password,
                        expression: "user.password",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "password",
                      maxlength: "24",
                      autocomplete: "off",
                      placeholder: "パスワード（必須）",
                      required: "",
                    },
                    domProps: { value: _vm.user.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "password", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-3" }),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.isTemporaryPassword,
                        expression: "user.isTemporaryPassword",
                      },
                    ],
                    attrs: {
                      name: "isTemporaryPassword",
                      id: "isTemporaryPassword",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.user.isTemporaryPassword)
                        ? _vm._i(_vm.user.isTemporaryPassword, null) > -1
                        : _vm.user.isTemporaryPassword,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.user.isTemporaryPassword,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.user,
                                "isTemporaryPassword",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.user,
                                "isTemporaryPassword",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.user, "isTemporaryPassword", $$c)
                        }
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "checkbox",
                      attrs: { for: "isTemporaryPasswordOn" },
                    },
                    [_vm._v("ユーザーにパスワードの変更を求める")]
                  ),
                  _c("br"),
                ]),
              ]),
            ]),
            _vm.isProfession
              ? _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(5),
                    _c("div", { staticClass: "col-9" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.user.profession,
                              expression: "user.profession",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { required: "" },
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.user,
                                  "profession",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.professionChanged,
                            ],
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }),
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v("医師"),
                          ]),
                          _c("option", { attrs: { value: "8" } }, [
                            _vm._v("麻酔科"),
                          ]),
                          _c("option", { attrs: { value: "6" } }, [
                            _vm._v("看護役職"),
                          ]),
                          _c("option", { attrs: { value: "2" } }, [
                            _vm._v("看護師"),
                          ]),
                          _c("option", { attrs: { value: "5" } }, [
                            _vm._v("看護補助"),
                          ]),
                          _c("option", { attrs: { value: "4" } }, [
                            _vm._v("薬剤師"),
                          ]),
                          _c("option", { attrs: { value: "9" } }, [
                            _vm._v("放射線技師"),
                          ]),
                          _c("option", { attrs: { value: "10" } }, [
                            _vm._v("臨床検査技師"),
                          ]),
                          _c("option", { attrs: { value: "7" } }, [
                            _vm._v("検査科"),
                          ]),
                          _c("option", { attrs: { value: "11" } }, [
                            _vm._v("保育士"),
                          ]),
                          _c("option", { attrs: { value: "12" } }, [
                            _vm._v("保育補助"),
                          ]),
                          _c("option", { attrs: { value: "13" } }, [
                            _vm._v("理学療法士"),
                          ]),
                          _c("option", { attrs: { value: "14" } }, [
                            _vm._v("管理栄養士"),
                          ]),
                          _c("option", { attrs: { value: "15" } }, [
                            _vm._v("社会福祉士"),
                          ]),
                          _c("option", { attrs: { value: "16" } }, [
                            _vm._v("救急救命士"),
                          ]),
                          _c("option", { attrs: { value: "3" } }, [
                            _vm._v("事務"),
                          ]),
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v("その他"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.isProfessionText
              ? _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(6),
                    _c("div", { staticClass: "col-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.professionText,
                            expression: "user.professionText",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          maxlength: "40",
                          autocomplete: "off",
                          placeholder: "職種名称",
                        },
                        domProps: { value: _vm.user.professionText },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.user,
                              "professionText",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(7),
                _c("div", { staticClass: "col-9" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.organizationId,
                          expression: "user.organizationId",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.user,
                            "organizationId",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.organizationOptions, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.id } },
                        [_vm._v(" " + _vm._s(option.displayName) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(8),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.description,
                        expression: "user.description",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      maxlength: "40",
                      autocomplete: "off",
                      placeholder: "肩書",
                    },
                    domProps: { value: _vm.user.description },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "description", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(9),
                _c("div", { staticClass: "col-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.privilege,
                        expression: "user.privilege",
                      },
                    ],
                    attrs: {
                      name: "privilege",
                      id: "member1",
                      type: "radio",
                      value: "1",
                      required: "",
                    },
                    domProps: { checked: _vm._q(_vm.user.privilege, "1") },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.user, "privilege", "1")
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio_label", attrs: { for: "member1" } },
                    [_vm._v("使用不可")]
                  ),
                  _c("br"),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.privilege,
                        expression: "user.privilege",
                      },
                    ],
                    attrs: {
                      name: "privilege",
                      id: "member2",
                      type: "radio",
                      value: "2",
                    },
                    domProps: { checked: _vm._q(_vm.user.privilege, "2") },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.user, "privilege", "2")
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio_label", attrs: { for: "member2" } },
                    [_vm._v("管理者")]
                  ),
                  _c("br"),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.privilege,
                        expression: "user.privilege",
                      },
                    ],
                    attrs: {
                      name: "privilege",
                      id: "member3",
                      type: "radio",
                      value: "3",
                    },
                    domProps: { checked: _vm._q(_vm.user.privilege, "3") },
                    on: {
                      change: function ($event) {
                        return _vm.$set(_vm.user, "privilege", "3")
                      },
                    },
                  }),
                  _c(
                    "label",
                    { staticClass: "radio_label", attrs: { for: "member3" } },
                    [_vm._v("参照のみ")]
                  ),
                  _c("br"),
                  _vm.isSuper
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.privilege,
                            expression: "user.privilege",
                          },
                        ],
                        attrs: {
                          name: "privilege",
                          id: "member9",
                          type: "radio",
                          value: "9",
                        },
                        domProps: { checked: _vm._q(_vm.user.privilege, "9") },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.user, "privilege", "9")
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.isSuper
                    ? _c(
                        "label",
                        {
                          staticClass: "radio_label",
                          attrs: { for: "member9" },
                        },
                        [_vm._v("システム管理権限")]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(10),
                _c("div", { staticClass: "col-9" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.roleId,
                          expression: "user.roleId",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.user,
                            "roleId",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.roles, function (role) {
                      return _c(
                        "option",
                        { key: role.id, domProps: { value: role.id } },
                        [_vm._v(" " + _vm._s(role.roleName) + " ")]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
            _vm.isSuper && this.$store.getters.hospital.isConference
              ? _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(11),
                    _c("div", { staticClass: "col-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.isUseConference,
                            expression: "user.isUseConference",
                          },
                        ],
                        attrs: {
                          name: "isUseConference",
                          id: "conferenceOn",
                          type: "radio",
                          value: "1",
                          required: "",
                        },
                        domProps: {
                          checked: _vm._q(_vm.user.isUseConference, "1"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.user, "isUseConference", "1")
                          },
                        },
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "radio_label",
                          attrs: { for: "conferenceOn" },
                        },
                        [_vm._v("使用する")]
                      ),
                      _c("br"),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.isUseConference,
                            expression: "user.isUseConference",
                          },
                        ],
                        attrs: {
                          name: "isUseConference",
                          id: "conferenceOff",
                          type: "radio",
                          value: "0",
                        },
                        domProps: {
                          checked: _vm._q(_vm.user.isUseConference, "0"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.user, "isUseConference", "0")
                          },
                        },
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "radio_label",
                          attrs: { for: "conferenceOff" },
                        },
                        [_vm._v("使用しない")]
                      ),
                      _c("br"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(12),
                _c("div", { staticClass: "col-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.isExcluded,
                        expression: "user.isExcluded",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.user.isExcluded)
                        ? _vm._i(_vm.user.isExcluded, null) > -1
                        : _vm.user.isExcluded,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.user.isExcluded,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.user,
                                "isExcluded",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.user,
                                "isExcluded",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.user, "isExcluded", $$c)
                        }
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "col-7" }),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn btn-block",
                attrs: { id: "register_button", type: "submit" },
              },
              [_vm._v("登録する")]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("ユーザー新規登録")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("ID")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("名称")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("ふりがな")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("パスワード")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("職種")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("職種名称")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("所属 (組織)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("label", [_vm._v("肩書")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("管理サイト権限")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("追加機能権限")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("ビデオ通話カンファレンス")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("共通連絡先の対象から外す")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }